"use client";
import Heading from "@/components/molecules/Heading";
import { useMediaQuery } from "@/hooks/useMediaQuery";
import { IRelatedPagesBlock } from "@/page-builder/fragments/RelatedPagesBlock/types";
import { CardArticle } from "@ama-pt/agora-design-system";
import React from "react";

export default function RelatedPagesBlock({
  title,
  pages,
  description,
}: IRelatedPagesBlock) {
  const { isDesktop, isMobile, isTablet } = useMediaQuery();

  return (
    <section className="container mx-auto flex flex-col gap-32 md:gap-64">
      <Heading title={title} description={description} />
      <div
        className={`grid ${
          pages.length === 1
            ? "grid-cols-1 md:grid-cols-1 xl:grid-cols-1"
            : pages.length === 2
            ? "grid-cols-1 md:grid-cols-2 xl:grid-cols-2 "
            : "grid-cols-1 md:grid-cols-2 xl:grid-cols-3"
        } gap-24`}
      >
        {pages?.map((page, index) => {
          const baseClasses = "w-full";
          const responsiveClass =
            index === 0 ? "md:col-span-2 xl:col-span-1" : "md:col-span-1";

          return (
            <div key={index} className={`${baseClasses} ${responsiveClass}`}>
              <CardArticle
                headingLevel="h2"
                title={page?.title}
                image={{
                  src: isDesktop
                    ? page.desktopImage?.url
                    : isTablet
                    ? page.tabletImage?.url
                    : isMobile
                    ? page.mobileImage?.url
                    : "",
                  alt: "",
                  height: 200,
                }}
                blockedLink
                mainAnchor={{
                  href: "/" + page?.slug || "",
                  iconOnly: true,
                  hasIcon: true,
                  "aria-label": `Ir para a página: ${page?.title}`, 
                }}
              />
            </div>
          );
        })}
      </div>
    </section>
  );
}
